<template>
    <div class="border mt-2 mb-2 p-2">
        <span
            ><i class="fa fa-calendar text-primary mr-1" title="Quando"></i
            ><strong>
                {{
                    $moment(historico.dataCadastro).format('DD/MM/YYYY HH:mm')
                }}</strong
            ></span
        ><br />
        <span
            ><i class="fa fa-tasks text-success mr-1" title="Ação"></i>
            <strong>{{ historico.acao }}</strong></span
        ><br />
        <span
            ><i
                class="fa fa-user-circle-o text-warning mr-1"
                title="Usuário"
            ></i>
            <strong>{{ historico.usuario }}</strong></span
        ><br />
        <span 
            v-if="historico.categoriaReprovacao"
            ><i 
                class="fa fa-exclamation-circle text-danger mr-1" 
                title="Categoria da reprovação"
            ></i>
            <strong>{{ historico.categoriaReprovacao }}</strong>
        </span>
        <span 
            v-if="historico.detalheReprovacao"
            >
            <br />
            <i 
                class="fa fa-comment-o text-danger mr-1"
                title="Detalhe"
            ></i>
            {{ historico.detalheReprovacao }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        historico: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    }
}
</script>
